<template>
  <div class="collection">
    <h1>{{ this.$data[this.$route.name].title }}</h1>
    <Gallery :images="this.$data[this.$route.name].imgs" :lookbook="this.$data[this.$route.name].lookbook" title="Collection"/>
    <div v-for="(item, index) in this.$data[this.$route.name].credits" v-bind:key=index>
      {{ item }}
    </div>
  </div>
</template>

<script>
import Gallery from '@/components/Gallery';

export default {
  data: function () {
    return {
      "FW20" : {
        title: "#definingmoments Take a new stance, make a statement!",
        lookbook : require("@/assets/collections/2019/lookbook-print.jpg"),
        imgs : [
          require("@/assets/collections/2019/1Shoulder_dress.jpg"),
          require("@/assets/collections/2019/kmlookbook1web.jpg"),
          require("@/assets/collections/2019/kmlookbook5web.jpg"),
          require("@/assets/collections/2019/grace_dress.jpg"),
          require("@/assets/collections/2019/kmlookbook13web.jpg"),
          require("@/assets/collections/2019/kmlookbook12web.jpg"),
          require("@/assets/collections/2019/micro_brazil_dress.jpg"),
          require("@/assets/collections/2019/kmlookbook10web.jpg"),
          require("@/assets/collections/2019/kmlookbook9web.jpg"),
          require("@/assets/collections/2019/kmlookbook8web.jpg"),
          require("@/assets/collections/2019/stylish_dress.jpg"),
          require("@/assets/collections/2019/kmlookbook14web.jpg"),
          require("@/assets/collections/2019/kmlookbook3web.jpg"),
          require("@/assets/collections/2019/kmlookbook16web.jpg"),
          require("@/assets/collections/2019/kmlookbook7web.jpg"),
          require("@/assets/collections/2019/kmlookbook4web.jpg"),
        ]
      },
      "SS2023" : {
        title : "Raise your vibration, Think colors!",
        lookbook : require("@/assets/collections/spring-summer/lookbook.jpg"),
        imgs : [
          require("@/assets/collections/spring-summer/km1-sans-sac.jpg"),
          require("@/assets/collections/spring-summer/km2.jpg"),
          require("@/assets/collections/spring-summer/km3.jpg"),
          require("@/assets/collections/spring-summer/km4.jpg"),
          require("@/assets/collections/spring-summer/km5.jpg"),
          require("@/assets/collections/spring-summer/km6.jpg"),
          require("@/assets/collections/spring-summer/km7.jpg"),
          require("@/assets/collections/spring-summer/km8.jpg"),
          require("@/assets/collections/spring-summer/km9.jpg"),
          require("@/assets/collections/spring-summer/km10.jpg"),
          require("@/assets/collections/spring-summer/km11.jpg"),
          require("@/assets/collections/spring-summer/km12.jpg"),
          require("@/assets/collections/spring-summer/km13.jpg"),
          require("@/assets/collections/spring-summer/km14.jpg"),
        ],
        credits: ["Model Stéphanie Lambert", "Mua Walter Denechere", "Photographer Stéphane Mounet"]
      },
      "swimwear" : {
        title : "Dive into the Magnificence, hold onto grace...",
        lookbook : require("@/assets/collections/swimwear/lookbook.jpg"),
        imgs : [
          require("@/assets/collections/swimwear/IMG_0316.jpg"),
          require("@/assets/collections/swimwear/M8-web.jpg"),
          require("@/assets/collections/swimwear/M2-web.jpg"),
          require("@/assets/collections/swimwear/IMG_0361.jpg"),
          require("@/assets/collections/swimwear/IMG_0378.jpg"),
          require("@/assets/collections/swimwear/IMG_0436.jpg"),
          require("@/assets/collections/swimwear/IMG_0386.jpg"),
          require("@/assets/collections/swimwear/M10-web.jpg"),
          require("@/assets/collections/swimwear/IMG_0455.jpg"),
        ]
      },
      "facemask" : {
        title : "Facemask",
        lookbook: '',
        imgs : [
          require("@/assets/collections/facemask/20201216_125317.jpg"),
          require("@/assets/collections/facemask/20201216_125523.jpg"),
          require("@/assets/collections/facemask/20201216_154253.jpg"),
          require("@/assets/collections/facemask/20201216_155336.jpg"),
          require("@/assets/collections/facemask/20201103_140005.jpg"),
          require("@/assets/collections/facemask/20201104_165553.jpg"),
          require("@/assets/collections/facemask/20201105_163408.jpg"),
        ]
      },
      "SS2024" : {
        title : "Nature always takes care of us... Let's stop failing taking care of HER!",
        lookbook : require("@/assets/collections/SS2021/lookbook.jpg"),
        imgs : [
          require("@/assets/collections/SS2021/7190.jpg"),
          require("@/assets/collections/SS2021/7199.jpg"),
          require("@/assets/collections/SS2021/7243.jpg"),
          require("@/assets/collections/SS2021/7275.jpg"),
          require("@/assets/collections/SS2021/7318.jpg"),
          require("@/assets/collections/SS2021/7357.jpg"),
          require("@/assets/collections/SS2021/7393.jpg"),
          require("@/assets/collections/SS2021/7423.jpg"),
          require("@/assets/collections/SS2021/7460.jpg"),
          require("@/assets/collections/SS2021/7475.jpg"),
          require("@/assets/collections/SS2021/7496.jpg"),
          require("@/assets/collections/SS2021/7520.jpg"),
        ],
        credits: ["Model Stéphanie Lambert", "Mua Nadeen Mateky", "Photographer Xavier Dollin"]
      },
      "FW21-22": {
        title : "Dance to life",
        //lookbook : require("@/assets/collections/FW21-22/lookbook.jpg"),
        lookbook : '',
        imgs : [
          require("@/assets/collections/FW21-22/duo_9673.jpg"),
          require("@/assets/collections/FW21-22/IMG_0042.jpg"),
          require("@/assets/collections/FW21-22/IMG_0062.jpg"),
          require("@/assets/collections/FW21-22/IMG_9500.jpg"),
          require("@/assets/collections/FW21-22/IMG_9833.jpg"),
          require("@/assets/collections/FW21-22/IMG_9881.jpg"),
          require("@/assets/collections/FW21-22/IMG_9919.jpg"),
          require("@/assets/collections/FW21-22/IMG_9960.jpg"),
          require("@/assets/collections/FW21-22/IMG_9986.jpg"),
          require("@/assets/collections/FW21-22/IMG_9996.jpg"),
          require("@/assets/collections/FW21-22/IMG_9997.jpg"),
          require("@/assets/collections/FW21-22/solo2_9854HD.jpg"),
          require("@/assets/collections/FW21-22/solo_9606modifHD.jpg"),
        ],
        credits: ["Model Stéphanie Lambert", "Mua Nadeen Mateky", "Photographer Stéphane Mounet"]
      },
      "FALL22": {
        title : "Fall 2022",
        //lookbook : require("@/assets/collections/FW21-22/lookbook.jpg"),
        lookbook : '',
        imgs : [
          require("@/assets/collections/fall-2022/oreltrench.jpg"),
          require("@/assets/collections/fall-2022/orellamee.jpg"),
          require("@/assets/collections/fall-2022/orelsymetrie.jpg"),
          require("@/assets/collections/fall-2022/orelcocoon.jpg"),
          require("@/assets/collections/fall-2022/orelgolden.jpg"),
          require("@/assets/collections/fall-2022/clemegyptian.jpg"),
          require("@/assets/collections/fall-2022/clemfuso2.jpg"),
          require("@/assets/collections/fall-2022/clemvoile.jpg"),
        ],
        credits: ["Models Aurélie Laurent & Clémentine Leduc", "Make Up & Hair Sébastien Poirier", "Photographer Stéphane Mounet"]
      },
      "SS2025": {
        title : "Vibe out, it's Summer!",
        lookbook : '',
        imgs : [
          //require("@/assets/collections/spring-summer-3/kate_macK210345.jpg"),
          require("@/assets/collections/spring-summer-3/kate_macK210359.jpg"),
          require("@/assets/collections/spring-summer-3/kate_macK210689.jpg"),
          require("@/assets/collections/spring-summer-3/kate_macK210724.jpg"),
          require("@/assets/collections/spring-summer-3/kate_macK210737.jpg"),
          require("@/assets/collections/spring-summer-3/kate_macK210917.jpg"),
          require("@/assets/collections/spring-summer-3/kate_macK210964.jpg"),
          require("@/assets/collections/spring-summer-3/kate_macK210991.jpg"),
          require("@/assets/collections/spring-summer-3/kate_macK211064.jpg"),
          require("@/assets/collections/spring-summer-3/kate_macK211177.jpg"),
          require("@/assets/collections/spring-summer-3/kate_macK211238.jpg"),
          require("@/assets/collections/spring-summer-3/kate_macK211264.jpg"),
        ],
        credits: ["Models Noémi", "Mua Nadeen Mateky", "Photographer Sabrina Lambletin"]
      }

    }
  },
  components: {
    Gallery
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Kate Mack - Collection',
    // all titles will be injected into this template
    titleTemplate: null,
    description: 'Kate Mack - Collection',
    meta: [
      {
        property: 'og:title',
        content: 'Kate Mack',
        // following template options are identical
        // template: '%s - My page',
        template: chunk => `${chunk} - ${this.$data[this.$route.name].title}`,
        vmid: 'og:title'
      }
    ]
  },
}
</script>

<style lang="scss" scoped>
div.collection {
  width: 100%;
  flex: 1;
}
</style>
